import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { BackToWorkspace } from "../Sections/BackToWorkspace";
import { Support } from "../Sections/Support";

export type InternalServerErrorProps = {
	customHtml: string | nil;
	supportTelephoneNumber: string | nil;
	supportEmailAddress: string | nil;
};

export const InternalServerError = (props: InternalServerErrorProps): ReactElement => {
	const {
		customHtml,
		supportEmailAddress,
		supportTelephoneNumber
	} = props;

	return (
		<>
			<h2>{localize("_Error500")}</h2>
			<Support
				customHtml={customHtml}
				supportEmailAddress={supportEmailAddress}
				supportTelephoneNumber={supportTelephoneNumber}
				emailSubjectTextTemplate="_Error500"
			/>
			<BackToWorkspace />
		</>
	);
};
InternalServerError.displayName = "InternalServerError";